"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_TOTAL_SUPPLY = exports.ERROR_REWARD_RATE = exports.ERROR_CLAIMING = exports.ERROR_EXITING = exports.ERROR_WITHDRAWING = exports.ERROR_DEPOSITING = void 0;
exports.ERROR_DEPOSITING = 'Error depositing into farm';
exports.ERROR_WITHDRAWING = 'Error withdrawing from farm';
exports.ERROR_EXITING = 'Error exiting from farm';
exports.ERROR_CLAIMING = 'Error claiming rewards';
exports.ERROR_REWARD_RATE = 'Error getting reward rate';
exports.ERROR_TOTAL_SUPPLY = 'Error getting total supply';
